import { MenuItem } from "./menu.types";

export const menuItems1: MenuItem[] = [
  { id: 1, label: "Dashboard", icon: "las la-home", to: "/", permissionId: 1 },
  { id: 2, label: "Roles", icon: "las la-check-circle", to: "/role", permissionId: 2 },
  { id: 3, label: "Map", icon: "las la-map", to: "/Map", permissionId: 3 },
  { id: 4, label: "Fleet", icon: "fa fa-light fa-chart-line", to: "/Fleet", permissionId: 4 },
  { id: 47, label: "TMS", icon: "las la-road", to: "/tms", permissionId: 47 },
  { id: 48, label: "Trips Odoo", icon: "las la-route", to: "/odoo-trips", permissionId: 47 },
  { id: 86, label: "program", icon: "las la-calendar-week", to: "/Sites", permissionId: 86 },
];
